import { LEVEL } from '@const/websocketMessage.constants';

export type Level = typeof LEVEL[keyof typeof LEVEL];

// deprecated
export interface AlertWS {
  header: string;
  url: string;
  text: string;
  level: Level;
  timestamp: number;
}

export const WS_TOKEN_PARAM = 'wsToken';

// new types
export interface WebsocketMessage<T = WebsocketReloadData | WebsocketLicenseData | WebsocketGrafanaData | WebsocketLLMData> {
  event: 'reload' | 'license' | 'grafana' | 'llm';
  data: T;
}

export interface WebsocketReloadData {
  type: 'health-status' | 'menu' | 'dashboard' | 'session' | 'top-menu';
}

export interface WebsocketLicenseData {
  status: 'warn' | 'error' | 'ok';
  type: 'license';
}

export interface WebsocketGrafanaData {
  active: boolean;
}

export interface WebsocketSessionTimeoutData {
  timeout: number;
}

export interface WebsocketLLMData {
  active: boolean;
}
